import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { cloneDeep } from 'lodash';

@Injectable()
export class EcapBroadcastService {
    private _navigationEvent: BehaviorSubject<any> = new BehaviorSubject(false);
    private _userInfoEvent: BehaviorSubject<any> = new BehaviorSubject(false);
    private _eventPipe: Subject<any>;
    private readonly _navigationDefaultEvent: any;
    private readonly _userInfo: any;

    constructor() {
        this._navigationDefaultEvent = {};
        this._userInfo = {};
        this._init();
    }

    private _init(): void {
        this._navigationEvent = new BehaviorSubject(cloneDeep(this._navigationDefaultEvent));
        this._userInfoEvent = new BehaviorSubject(cloneDeep(this._userInfo));
        this._eventPipe = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    broadcastNavigationEvent(value, opts = { emitEvent: true }): void {
        let config = this._navigationEvent.getValue();
        config = value;
        if (opts.emitEvent === true) {
            this._navigationEvent.next(config);
        }
    }

    onNavigationEvent(): Observable<any> {
        return this._navigationEvent.asObservable();
    }

    resetNavigationEvent(): void {
        this._navigationEvent.next(cloneDeep(this._navigationDefaultEvent));
    }

    // user inof
    broadcastUserInfoEvent(value): void {
        this._userInfoEvent.next(value);
    }

    onUserInfoEvent(): Observable<any> {
        return this._userInfoEvent.asObservable();
    }

    /**
     * ? event pipe
     * param value EventValue
     */
    broadcastEventPipe(value): void {
        this._eventPipe.next(value);
    }

    onEventPipe(): Observable<any> {
        return this._eventPipe.asObservable();
    }
}
